LocationTrackingInterceptor = ($rootScope, $location, LocationTrackingService) ->
  $rootScope.$on "$locationChangeSuccess", (event) ->
    LocationTrackingService.saveLocation()

LocationTrackingInterceptor.$inject = [
  "$rootScope",
  "$location",
  "LocationTrackingService"
]

module.exports = LocationTrackingInterceptor


// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/location-tracking/location-tracking-interceptor.coffee